import { Module } from 'vuex';
import { RootState } from '@/store';
import { getters } from '@/store/modules/backoffice/messages/getters';
import { actions } from '@/store/modules/backoffice/messages/actions';
import { mutations } from '@/store/modules/backoffice/messages/mutations';
import { Grid } from '@/models/Grid.model';
import { BackofficeMessageModel } from '@/models/BackofficeMessage.model';
import { MESSAGES_ALL_OFFICE_LIST } from '@/types/backoffice/messages.types';

export interface MessagesState {
  messagesByCustomer: Grid<BackofficeMessageModel>;
  messagesAllOfficeList: Grid<BackofficeMessageModel>;
  messagesByCustomerErrors: string[];
  openCreateMessageModal: boolean;
  openCreateMessageModalErrors: string[];
  openDeleteMessagesModal: boolean;
  openDeleteMessagesModalErrors: string[];
  messagesLoading: boolean;
}

export const initialState = ((): MessagesState => {
  return {
    messagesByCustomer: {} as Grid<BackofficeMessageModel>,
    messagesAllOfficeList: {} as Grid,
    messagesByCustomerErrors: [],
    openCreateMessageModal: false,
    openCreateMessageModalErrors: [],
    openDeleteMessagesModal: false,
    openDeleteMessagesModalErrors: [],
    messagesLoading: false,
  };
});

export const messages: Module<MessagesState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
